"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMapGl = require("react-map-gl");

var _useInteractiveLayers = _interopRequireDefault(require("../hooks/useInteractiveLayers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getLayersForSourceId = function getLayersForSourceId(sourceId, layers) {
  return layers.filter(function (layer) {
    return layer.source === sourceId;
  });
};
/**
 * Handles creating sources and layers for the map,
 * as well as managing feature states
 */


var Layers = function Layers(_ref) {
  var sources = _ref.sources,
      layers = _ref.layers;
  // interactive layers hook adds hovered / selected states to features
  (0, _useInteractiveLayers["default"])();
  if (!layers) return null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, sources.map(function (_ref2) {
    var id = _ref2.id,
        source = _objectWithoutProperties(_ref2, ["id"]);

    return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Source, _extends({
      key: id,
      id: id
    }, source), getLayersForSourceId(id, layers).map(function (_ref3) {
      var beforeId = _ref3.beforeId,
          interactive = _ref3.interactive,
          layer = _objectWithoutProperties(_ref3, ["beforeId", "interactive"]);

      return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Layer, _extends({
        key: layer.id,
        beforeId: beforeId
      }, layer));
    }));
  }));
};

Layers.__docgenInfo = {
  "description": "Handles creating sources and layers for the map,\nas well as managing feature states",
  "methods": [],
  "displayName": "Layers"
};
var _default = Layers;
exports["default"] = _default;